import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent {}
